<template>
  <div v-if="ipPoolList.length === 0">-</div>
  <div v-else>
    <p v-for="(e, i) in poolList" :key="i">{{ e.ipPoolName }}</p>
  </div>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";
import type { GetPolicy } from "@/apis/NwPolicyApi";

/** インターネットType4のポリシーのIP Pool表示が出来るコンポーネント */
export default defineComponent({
  name: "PolicyIpPool",
  props: {
    /** IPプールリスト */
    ipPoolList: {
      type: Array as PropType<GetPolicy["ipPoolList"]>,
      required: true,
    },
  },
  computed: {
    /** IPプールリストを昇順でソートした一覧 */
    poolList(): GetPolicy["ipPoolList"] {
      return this.ipPoolList.sortBy(["ipPoolName", "asc"]);
    },
  },
});
</script>

<style scoped lang="scss">
p {
  margin: 0;
}
</style>
